import { Link } from "react-router-dom";
import { useT } from "../../lib/texte";

// `logo.svg` hat viewBox="0 0 321.5 150" — bei 30 px Höhe sind das 64 px
// Breite. Beide Zahlen stehen als Attribute am <img>, damit der Browser den
// Platz schon vor dem Laden reserviert und die Kopfleiste beim ersten
// Anstrich nicht springt (Layout Shift).
const LOGO_H = 30;
const LOGO_W = 64;

/**
 * Bildmarke plus Produktwort.
 *
 * `logo.svg` ist die LILASp-Wortmarke aus webgis, unverändert übernommen: sie
 * trägt den Namen als graue Pfade (#706f6f) mit dem Petrolpunkt (#045863).
 * Das Produktwort daneben ist ein eigenes Element, damit es der Hausschrift
 * und dem Thema folgen kann (`.marke span` in app.css: Anzeigeschrift, 16 px,
 * Akzentfarbe).
 *
 * `--logo-filter` hellt die graue Marke im dunklen Thema auf; ohne ihn
 * versinkt sie im Grund. Unter 640 px blendet app.css das Produktwort IN DER
 * KOPFLEISTE aus — dort gehört der Platz den Reitern; auf der Anmeldeseite
 * bleibt es stehen.
 *
 * Der Kompass-Chip aus dem webgis-Kopf fehlt hier absichtlich: das ist dessen
 * Produktzeichen, nicht unseres.
 */
export function Logo({ zu = "/" }: { zu?: string }) {
  const { t } = useT();
  return (
    <Link to={zu} className="marke ring-focus" aria-label={`${t.marke.name} ${t.marke.produkt}`}>
      <img src="/logo.svg" alt={t.marke.name} width={LOGO_W} height={LOGO_H} />
      <span aria-hidden>{t.marke.produkt}</span>
    </Link>
  );
}
